import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@workos-inc/authkit-react';

const AuthHandler = () => {
  const { user, isLoading, signIn } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading) {
      if (user) {
        navigate('/profile');
      } else {
        signIn();
      }
    }
  }, [user, isLoading, navigate, signIn]);

  return <div>Loading...</div>;
};

export default AuthHandler;
